const marketsList = [
  {
    value: 'ME',
    label: 'ME',
  },
  {
    value: 'EUROPE',
    label: 'Europe',
  },
  {
    value: 'LATAM',
    label: 'Latam',
  },
  {
    value: 'ROW',
    label: 'ROW',
  },
  {
    value: 'SEA',
    label: 'SEA',
  },
  {
    value: 'UK',
    label: 'UK',
  },
  {
    value: 'SA',
    label: 'SA',
  },
  {
    value: 'US',
    label: 'US',
  },
  {
    value: 'GC',
    label: 'GC',
  },
  {
    value: 'AUS',
    label: 'AUS',
  },
  {
    value: 'EAST_ASIA',
    label: 'East Asia',
  },
];

export { marketsList };
